module.exports = __webpack_public_path__ + "static/media/Chevron_Right 2.1243d226.svg";